'use client';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { fadeIn } from '@/lib/animations';
import { cn } from '@/lib/utils';

const stats = [
	{ value: '98%', label: 'On-Time Delivery Rate' },
	{ value: '99.7%', label: 'Order Accuracy' },
	{ value: '25+', label: 'Wisconsin Counties Served' },
	{ value: '500K+', label: 'Square Feet of Warehouse Space' },
];

export function Stats() {
	const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.05,
		rootMargin: '200px 0px',
	});

	return (
		<section className="py-24 bg-brand-600 text-white">
			<div className="container mx-auto px-4 md:px-6">
				<div className="grid grid-cols-2 md:grid-cols-4 gap-8">
					{stats.map((stat, index) => (
						<motion.div
							key={index}
							ref={ref}
							initial="hidden"
							animate={inView ? 'show' : 'hidden'}
							variants={fadeIn('up', 0.1 * index)}
							className={cn(
								'text-center',
								index < stats.length - 1 && 'border-r border-brand-500'
							)}
						>
							<div className="text-4xl md:text-5xl font-bold mb-2">{stat.value}</div>
							<div className="text-sm md:text-base text-brand-100">{stat.label}</div>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
}
